<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
      <el-form-item label="公众号">
        <el-tag v-if="formLabelAlign.app_id!=null" style="margin-right:10px">{{ name }}</el-tag>
        <el-button type="success" size="mini" :disabled="ids!=null" @click="choosesimer">选择公众号</el-button>
      </el-form-item>
      <!-- <el-form-item label="ghId">
        <el-input v-model="formLabelAlign.gh_id" />
      </el-form-item> -->
      <!-- <el-form-item label="管理员手机号">
        <el-input v-model="formLabelAlign.phone_name" />
      </el-form-item> -->
      <el-form-item label="管理员微信号">
        <el-autocomplete
          v-model="formLabelAlign.phone_vx_account"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          @select="handleSelect"
        />
        <!-- <el-input v-model="formLabelAlign.phone_vx_account" /> -->
      </el-form-item>
      <el-form-item label="公众号密码">
        <el-input v-model="formLabelAlign.password" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="smbiter">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择公众号"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <chooseaccount ref="simnre" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import { createscannumberinfo, updatascannumberinfo, getWeChatList } from '@/api/sourceMaterial.js'
import chooseaccount from './chooseaccount.vue'
export default {
  components: { chooseaccount },
  data() {
    return {
      type: null,
      ids: null,
      dialogVisible: false,
      labelPosition: 'right',
      formLabelAlign: {
        app_id: null,
        // gh_id: '',
        // phone_name: '',
        phone_vx_account: '',
        password: '',
        gh_id: null
      },
      name: ''

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async send(type, item) {
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        this.ids = item.id
        this.formLabelAlign.app_id = item.app_id
        this.name = item.app_id_text
        // this.formLabelAlign.gh_id = item.gh_id
        this.formLabelAlign.phone_name = item.phone_name
        this.formLabelAlign.phone_vx_account = item.phone_vx_account
        this.formLabelAlign.password = item.password
      }
    },
    async smbiter() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.app_id == null) {
        this.$message.error('请选择公众号')
        return
      }
      // eslint-disable-next-line eqeqeq
      // if (this.formLabelAlign.gh_id == '') {
      //   this.$message.error('请填写ghId')
      //   return
      // }
      // eslint-disable-next-line eqeqeq
      /* if (this.formLabelAlign.phone_name == '') {
        this.$message.error('请填写管理员手机号')
        return
      } */
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.phone_vx_account == '') {
        this.$message.error('请选择管理员微信号')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.password == '') {
        this.$message.error('请填写管理员密码')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        console.log('新增')
        const data = await createscannumberinfo(this.formLabelAlign)
        console.log('data', data)
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        this.$emit('updata')
      } else {
        const datas = await updatascannumberinfo({
          ...this.formLabelAlign,
          id: this.ids
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updata')
        console.log('datas', datas)
        console.log('编辑')
      }
    },
    choosesimer() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.simnre.sendrs()
      }, 100)
    },
    callback(val) {
      this.dialogVisible = false
      this.formLabelAlign.app_id = val.app_id
      this.formLabelAlign.gh_id = val.gh_id
      this.name = val.account_name
      console.log('val', val)
    },
    async querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      const data = await getWeChatList({ phone_vx_account: queryString })
      cb(data.data ? data.data.map((item) => { return { value: item.phone_vx_account, address: item.id } }) : [])
    },
    handleSelect(item) {

    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
